import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Dialog, Button } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';

const CurrencyExchangeDeleteModal = ({ onSubmit, onClose, title, message, submitButtonName }) => {
  const { t } = useTranslation();

  return (
    <Modal visible centered fullScreen>
      <Dialog
        dialog={{
          heading: title,
          content: <>{message}</>,
          footer: (
            <>
              <Button label={submitButtonName} colored onClick={onSubmit} />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

export { CurrencyExchangeDeleteModal };
